import React, { useEffect, useState } from "react";

const Nav = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [activePg, setActivePg] = useState("");
  const menu_options = [
    "home",
    "about-us",
    "products",
    "faq",
    "blogs",
    "contact-us",
  ];

  useEffect(() => {
    let path = window.location.pathname;
    setActivePg(path.replace("/", ""));
  }, []);
  return (
    <div className="navbar_main">
      <div className="container navbar">
        <div className="nav_logo">
          <img src="/img/logo.webp" alt="logo" />
        </div>
        <ul className={showSidebar ? "menu_active" : "menu"}>
          {menu_options.map((item) => (
            <li
              className={activePg === item ? "active dm-sans" : "dm-sans"}
              key={item}
              onClick={() => setActivePg(item)}
            >
              <a href={`/${item}`}>{item.replace("-", " ")}</a>
            </li>
          ))}
        </ul>

        <div className="navbar_options">
          <i className="bi bi-search"></i>
          <i className="bi bi-heart"></i>
          <i className="bi bi-cart"></i>
          <i className="bi bi-list" onClick={() => setShowSidebar(true)}></i>
        </div>
      </div>
    </div>
  );
};

export default Nav;
